<template>
    <canvas class="map-canvas" ref="canvas" :width="width" :height="height" @mousedown="handleMouseDown" @mousemove="handleMouseMove"></canvas>
</template>

<script>
var geometryFactory = new jsts.geom.GeometryFactory();

import { defaultRegionStore } from '../geometries';
import * as nodes from '../nodes';

export default {
    name: 'regions-map',
    data() {
        return {
            width: 400,
            height: 400,
            bus: window.bus,
            movingAssetKey: null
        }
    },
    methods: {
        handleMouseDown(e) {
            if (e.buttons == 0) return;

            let closest = "red";
            let closestDistanceSquared = Infinity;

            for (let asset of Object.values(window.bus.assets)) {
                let deltaX = e.offsetX - asset.currentPosition.x;
                let deltaY = e.offsetY - asset.currentPosition.y;

                let distance = deltaX * deltaX + deltaY * deltaY;

                if (distance < closestDistanceSquared) {
                    closest = asset.key;
                    closestDistanceSquared = distance;
                }
            }

            this.movingAssetKey = closest;

            window.bus.setPosition(this.movingAssetKey, e.offsetX, e.offsetY);
        },
        handleMouseMove(e) {
            if (e.buttons == 0) return;

            window.bus.setPosition(this.movingAssetKey, e.offsetX, e.offsetY);
        },
        drawGeometry(context, geometry) {
            context.beginPath();

            for (let coordinate of geometry.getCoordinates()) {
                context.lineTo(coordinate.x, coordinate.y);
            }

            context.closePath();
        },
        drawGraph(context, label, cornerX, cornerY, history) {
            context.font = "12px sans-serif";
            context.fillStyle = "black";
            context.textBaseline = "top";

            context.fillText(label, cornerX, cornerY);

            let topY = cornerY - 3;
            let bottomY = topY + 16;
            let leftX = 50;
            let spacing = 2;

            // Draw a top and bottom line:
            let drawLine = cornerY => {
                context.beginPath();
                context.moveTo(leftX, cornerY);
                context.lineTo(leftX + 100 * spacing, cornerY);

                context.setLineDash([3, 3]);
                context.strokeStyle = "silver";
                context.stroke();
                context.setLineDash([]);
            };

            drawLine(topY);
            drawLine(bottomY);

            // Draw the data line:
            context.beginPath();

            for (let i = 0; i < history.length; i++)
            {
                context.lineTo(leftX + i * spacing, history[i] ? topY : bottomY);
            }

            context.strokeStyle = "red";
            context.stroke();
        },
        paint() {
            let canvas = this.$refs.canvas;
            var context = canvas.getContext('2d');

            context.save();

            context.clearRect(0, 0, canvas.width, canvas.height);

            // Paint the result:
            let result = window.bus.result;

            if (result.type == nodes.Result.groupingType) {
                let value = result.value;

                for (let geometry of value.geometries) {
                    this.drawGeometry(context, geometry.value.geometry);

                    context.fillStyle = "#eeeeee";
                    context.fill();
                }

                for (let geometry of value.geometries) {
                    this.drawGeometry(context, geometry.value.geometry);

                    context.strokeStyle = "#888888";
                    context.stroke();
                }
            }

            /*
            if (window.bus.histories.level !== undefined) this.drawGraph(
                context, "Level:", 8, 8, window.bus.histories.level);

            if (window.bus.histories.edge !== undefined) this.drawGraph(
                context, "Edge:", 8, 38, window.bus.histories.edge);
            */

            // Paint the geometry outlines:
            for (let region of Object.values(defaultRegionStore.regions)) {
                this.drawGeometry(context, region.geometry);

                context.strokeStyle = "silver";
                context.setLineDash([5, 5]);
                context.stroke();
                context.setLineDash([]);
            }

            for (let asset of Object.values(window.bus.assets)) {
                let cursorPosition = asset.currentPosition;

                let cursorGeometry = geometryFactory.createPoint(new jsts.geom.Coordinate(cursorPosition.x, cursorPosition.y));

                context.beginPath();
                context.arc(cursorPosition.x, cursorPosition.y, 5, 0, 2 * Math.PI);
                context.fillStyle = asset.colour;
                context.fill();

                context.restore();
            }
        }
    },
    mounted() {
        window.bus.$on("result-changed", this.paint.bind(this));

        this.paint();
    }
}
</script>

<style scoped lang="less">
</style>
